import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import flatpickrLocale from 'flatpickr/dist/l10n/zh-tw'

export default class extends Controller {
  static targets = ['element']
  static values = {
    dateFormat: { type: String, default: 'Y-m-d H:i' },
    useMobile: { type: Boolean, default: true },
    enableTime: { type: Boolean, default: true },
    minDate: { type: String, default: null },
    maxDate: { type: String, default: null }
  }

  connect() {
    const options = {
      locale: {
        ...flatpickrLocale.zh_tw,
        firstDayOfWeek: 1,
      },
      dateFormat: this.dateFormatValue,
      disableMobile: !this.useMobileValue,
      enableTime: this.enableTimeValue,
      allowInput: true,
      parseDate: (dateStr, format) => {
        // 移除非數字
        const clean = dateStr.replace(/\D/g, "")

        // 支援輸入 20180901 => 2018-09-01
        if (/^\d{8}$/.test(clean)) {
          const year = clean.slice(0, 4)
          const month = clean.slice(4, 6)
          const day = clean.slice(6, 8)
          return new Date(`${year}-${month}-${day}`)
        }

        // 預設處理（讓 Flatpickr 繼續支援正常格式）
        return flatpickr.parseDate(dateStr, format)
      }
    };

    if (this.hasMinDateValue && this.minDateValue) {
      options.minDate = this.minDateValue
    }

    if (this.hasMaxDateValue && this.maxDateValue) {
      options.maxDate = this.maxDateValue
    }

    this.instance = flatpickr(this.elementTargets, options);
  }

  disconnect() {
    this.instance?.destroy()
  }
}
